import React from 'react'
import Form from 'react-bootstrap/Form';
import { AgGridReact } from "ag-grid-react";
import { useState } from 'react';
import { Divider } from 'rsuite';

function PatientPrescription() {

    const defaultColDef = {
        flex: 1,
    };
    const [colDefs, setColDefs] = useState([
        { field: "drugName", headerName: "Drug Name & Strength" },
        { field: "dosage", headerName: "Dosage" },
        { field: "frequency", headerName: "How Often" },
    ]);
    const [rowData, setRowData] = useState([
        { drugName: "Mastocytosis Gastrocrom 100 mg ampules", dosage: "200 mg - 2 ampules ", frequency: "4x daily 30 min before meals" },
        { drugName: "Mastocytosis Gastrocrom 100 mg ampules", dosage: "200 mg - 2 ampules ", frequency: "4x daily 30 min before meals" },
        { drugName: "Mastocytosis Gastrocrom 100 mg ampules", dosage: "200 mg - 2 ampules ", frequency: "4x daily 30 min before meals" },
    ]);

    return (
        <>
            <main style={{ width: "100%", height: "100%" }}>
                <div className="row">
                    <div style={{ borderBottom: "1px dashed gray", paddingBottom: "1rem" }} className="col-12 mb-4 d-flex justify-content-between">

                        <div className="d-flex">
                            <h4 className='m-0 p-3'>
                                Prescription
                            </h4>

                        </div>

                        <div className='d-flex align-items-center justify-content-end gap-3'>
                            <div className='d-flex align-items-center gap-3'>
                                <div className="position-relative div-okij8ijj">
                                    <input type="text" className="form-control div-TzEiOdMeYO" placeholder='Search here' style={{ padding: "0px 1.7rem 0px .5rem", borderRadius: ".3rem" }} />
                                    <div className="position-absolute" style={{ top: "10px", right: '8px' }}>
                                        <button style={{ background: "none", border: 'none', }}><i class="fa-solid fa-magnifying-glass"></i></button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    {/* <div className="col-12 d-flex align-items-center mb-4 justify-content-end">
           
        </div> */}
                </div>
                <div className="row">
                    <div style={{ height: "42rem" }} className="col-12 row">
                        <div className="col-5 p-3" style={{ overflowY: "scroll", border: "1px solid #D6DADD", borderRadius: "6px", height: "100%" }}>
                            <span style={{ backgroundColor: "#C6FFD7", borderRadius: "5px", cursor: "pointer" }} className="d-flex p-2 align-items-center justify-content-between my-1">
                                <div className="d-flex align-items-center gap-2">
                                    <span>
                                        <img src="/Images/Group9.png" alt="" />
                                    </span>
                                    <span className="d-flex flex-column align-items-start">
                                        <span className="m-1">Diabetes</span>
                                        <span style={{ color: "gray" }} className="m-1">Sat, 23 Jul 2020, 01:24 PM</span>
                                    </span>
                                </div>
                                <span className="d-flex flex-column align-items-start">
                                    <span className="m-1" style={{ fontSize: "0.8rem" }}>Assigned to  <span style={{ color: "#2662F0" }} className="mx-1">DR. Rahul</span></span>
                                    <span className="m-1" style={{ fontSize: "0.8rem" }}>Visit Type  <span style={{ color: "#2BC155" }} className="mx-1">In-person</span></span>
                                </span>
                            </span>

                        </div>
                        <div className="col-7 px-3">
                            <div className="col-12 d-flex flex-column" style={{ overflowY: "scroll", border: "1px solid #D6DADD", borderRadius: "6px", height: "100%", backgroundColor: "white" }}>
                                <div className="d-flex py-3 px-4 col-12" style={{ borderBottom: "1px dashed gray" }}>
                                    <span>Prescription</span>
                                </div>
                                <div className="d-flex flex-column px-4 py-4">
                                    <div className="d-flex align-items-center justify-content-between my-2">
                                        <h5>Rohan</h5>
                                        <span>Age : 68</span>
                                        <span>Blood Group : O+</span>
                                        <span>BP : 120/80</span>
                                        <span>Pulse : 40 – 60 bpm</span>
                                        <span style={{ color: "gray" }}>#123456abc</span>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between my-2">
                                        <span className="d-flex">Assigned to <span className="mx-1" style={{ color: "#2662F0" }}>DR. Kavya</span></span>
                                        <span className="d-flex">Department <span className="mx-1" style={{ color: "#2662F0" }}>General Physician</span></span>
                                        <span style={{ color: "gray" }}>Sat, 23 Jul 2020, 01:24 PM</span>
                                    </div>
                                    <Divider className="my-2" style={{ borderColor: "gray" }} />
                                   
                                </div>

                                <Divider className="my-2" style={{ borderColor: "gray" }} />
                                <div className="d-flex flex-column p-2">
                                    <h6>Notes :</h6>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
                                </div>
                                <Divider className="my-2" style={{ borderColor: "gray" }} />
                                <div className="d-flex flex-column">
                                    <h6>Medicine :</h6>
                                    <div style={{ width: "100%", height: "12rem" }}>
                                        <AgGridReact
                                            rowData={rowData}
                                            columnDefs={colDefs}
                                            defaultColDef={defaultColDef}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
           




        </main >

        </>
    )
}

export default PatientPrescription